import { createSelector } from 'reselect';
import { compare } from './../utility/CompareUtils';

const Audit = 'audit';

const selectAllAudits = (state) => state.get(Audit).get('allAudits');
const getAllAudits = createSelector(selectAllAudits, (data) => {
  const sortedList = data.sort((a, b) => compare(b.get('timestamp'), a.get('timestamp')));
  return sortedList;
});

const selectUserAudits = (state) => state.get(Audit).get('userAudits');
const getAllUserAudits = createSelector(selectUserAudits, (data) => {
  const sortedList = data.sort((a, b) => compare(b.get('timestamp'), a.get('timestamp')));
  return sortedList;
});

const selectAuditTypes = (state) => state.get(Audit).get('auditTypes');
const getAuditTypes = createSelector(selectAuditTypes, (data) => {
  const sortedList = data.sort((a, b) => compare(a, b));
  return sortedList;
});

const selectIsLoading = (state) => state.get(Audit).get('isLoading');
const getLoadingStatus = createSelector(selectIsLoading, (data) => data);

const selectPagination = (state) => state.get(Audit).get('audits');
const getPagination = createSelector(selectPagination, (data) => {
  return {
    current: data.get('number') + 1,
    total: data.get('totalElements'),
    pageSize: data.get('size'),
    size: 'small',
    showSizeChanger: true,
    position: 'bottom',
  };
});

export { getAllAudits, getAllUserAudits, getLoadingStatus, getAuditTypes, getPagination };
